document.addEventListener('DOMContentLoaded',()=>{
  document.querySelectorAll('.og-nav-details').forEach(details=>{
    if(details.querySelector('summary')?.textContent.trim().startsWith('Services')){
      const item=details.closest('li');
      if(item)item.innerHTML='<a href="/pages/workshop-services" class="header__menu-item list-menu__item link link--text focus-inset"><span>Services</span></a>';
    }
  });

  const mobile=document.querySelector('.menu-drawer__navigation>.menu-drawer__menu');
  if(mobile){
    const labels=[...mobile.querySelectorAll('.og-mobile-label')];
    const servicesLabel=labels.find(label=>label.textContent.trim()==='Services');
    if(servicesLabel){
      const direct=document.createElement('li');
      direct.innerHTML='<a href="/pages/workshop-services" class="menu-drawer__menu-item list-menu__item link link--text focus-inset og-mobile-primary">Services</a>';
      servicesLabel.before(direct);
      let current=servicesLabel;
      while(current){
        const next=current.nextElementSibling;
        current.remove();
        if(!next||next.querySelector('.og-mobile-primary'))break;
        current=next;
      }
    }
  }
});
